import { AlertCircle } from 'lucide-react';

import { AppTilesGrid } from '@/components/home/AppTilesGrid';
import { MasterHeader } from '@/components/home/MasterHeader';
import { OverallStats } from '@/components/home/OverallStats';
import { StreakHero } from '@/components/home/StreakHero';
import { WeekStrip } from '@/components/home/WeekStrip';
import { HomeSkeleton } from '@/components/ui/skeletons';
import { useApps, useOverallStats, useOverallStreak } from '@/lib/queries';

export function HomeRoute() {
  const apps = useApps();
  const streak = useOverallStreak();
  const stats = useOverallStats();

  const loading = apps.isLoading || streak.isLoading || stats.isLoading;
  const error = apps.error ?? streak.error ?? stats.error;

  return (
    <div className="min-h-screen">
      <MasterHeader />
      {loading && <HomeSkeleton />}
      {error && <ErrorState message={error.message} />}
      {!loading && !error && (
        <main className="mx-auto flex max-w-5xl flex-col gap-2 px-4 py-6 sm:px-6">
          {streak.data && <StreakHero streak={streak.data} />}
          {apps.data && <AppTilesGrid apps={apps.data.apps} />}
          {streak.data && (
            <WeekStrip
              activity={streak.data.week_activity}
              paused={streak.data.week_paused}
              weekStart={streak.data.week_start}
            />
          )}
          {stats.data && <OverallStats stats={stats.data} />}
        </main>
      )}
    </div>
  );
}

function ErrorState({ message }: { message: string }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <AlertCircle className="text-destructive size-8" />
      <p className="font-display text-lg">Something went wrong</p>
      <p className="text-muted-foreground max-w-md text-sm">{message}</p>
    </div>
  );
}
